<script setup>
import { ref, onMounted, computed } from 'vue';
import { useCommonStore } from '@/stores/common';
import $ from 'jquery';
import axios from 'axios';

const props = defineProps(['feedbackSource','backgroundColor']);
const store = useCommonStore();

const imgURL = ref(store.cloudfrontImgURL);
const clientFeedbackEndpoint = ref(store.clientFeedbackURL());
const cardSingleName = ref('');
const cardSingleType = ref('');
const cardSingleComment = ref('');
const cardOneName = ref('');
const cardOneType = ref('');
const cardOneComment = ref('');
const cardOneId = ref(0);
const cardSingleId = ref(0);
const cardTwoName = ref('');
const cardTwoType = ref('');
const cardTwoComment = ref('');
const cardTwoId = ref(1);
const cardThreeName = ref('');
const cardThreeType = ref('');
const cardThreeComment = ref('');
const cardThreeId = ref(2);
const cardOneBlur = ref(true);
const cardTwoBlur = ref(false);
const cardThreeBlur = ref(true);
const feedbackSourceType = ref(props.feedbackSource);
const backgroundColor = ref(props.backgroundColor);
const clientComments = ref([]);
const clientCommentsNoNetwork = ref([
    {name: 'David Bridger',type: 'Private Client - Retired PwC Partner',comments: 'I am David Bridger, a chartered accountant and former PwC partner. I have been advised by clarity for about 30 years.  I particularly value having an annual meeting with my clarity Advisor covering a review of my and my family’s financial positions and being able to raise a whole range of specific financial issues personal to me. Amongst other things, clarity also advise me at least every 3 months about the collective funds they do and no longer recommend for investment. I have always followed their recommendations and have proven over several years that the investment gains made as a result of these changes, easily outweigh the fee consequences of taking up this element of Clarity’s services. Finally, I also value the ability to raise financial questions throughout the year and getting prompt personalised replies on such diverse subjects as ISA recommendations, Trust investments, SIPP investments, Life insurance policies, Capital Gains tax mitigation, etc.'},
    {name: 'Jonathan & Kathrin',type: 'Private Client - Retired PwC Partner',comments: 'Claire has advised me and my wife for many years. In that time she has kept our finances under control with annual meetings bringing some discipline to our affairs with a structured approach to portfolio management & fund selection. Claire has a nice down-to-earth approach. Each meeting starts with her understanding our goals and building flexibility into the planning as needed. Critically Claire anticipates the future and has brought things to our attention (in areas such as inheritance tax and pension planning) which would have been beyond us, but which were important in allowing us flexibility with retirement. Although we have chosen an arrangement with one annual meeting, Claire and her team keep us up to date with regulatory and similar changes and are also responsive to ad hoc queries and very happy to explain what can be obscure matters. Ultimately working with Claire is like working with a friend - always professional but with a sense of humour and a genuine interest in what we’re up to.'},
    {name: 'JT',type: 'Private Client - Retired PwC Partner',comments: 'I\'ve been supported by clarity for close to thirty years and I\'ve always found them to be highly professional, committed, informative and very supportive.  Their timely advice has really helped me through my professional life, through the birth of our children and now into retirement.  I value their financial insights and their commitment, including challenging me when I\'m about to follow the latest fad.'},
]);
const clientFeedbackBackground = computed(() => `url('${imgURL.value}client-feedback-background.svg')`);
const clientFeedbackBlueBackground = computed(() => `url('${imgURL.value}client-feedback-background-blue.png')`);

function loadClientComments() {
    axios.get(clientFeedbackEndpoint.value) 
        .then(res => {
            const comments = res.data;
            if(feedbackSourceType.value === 'pwc') {
                comments.forEach(elm => {
                    if(elm.type.includes('PwC') || elm.type.includes('PricewaterhouseCoopers')) {
                        clientComments.value.push(elm);
                    }
                });
            } else {
                clientComments.value = comments;
            }
        })
        .finally(() => {
            if(clientComments.value.length === 0) {
                clientComments.value = clientCommentsNoNetwork.value;
            }
            setClientComments();
        })
        .catch(err => {
            console.log(err);
        })

}

function setClientComments() {
    const commentCount = clientComments.value.length;
    cardOneId.value = 1;
    cardOneName.value = clientComments.value[1].name;
    cardOneType.value = clientComments.value[1].type;
    cardOneComment.value = clientComments.value[1].comments;
    cardTwoId.value = 0;
    cardTwoName.value = clientComments.value[0].name;
    cardTwoType.value = clientComments.value[0].type;
    cardTwoComment.value = clientComments.value[0].comments;
    cardThreeId.value = commentCount-1;
    cardThreeName.value = clientComments.value[commentCount-1].name;
    cardThreeType.value = clientComments.value[commentCount-1].type;
    cardThreeComment.value = clientComments.value[commentCount-1].comments;
    cardSingleId.value = 0;
    cardSingleName.value = clientComments.value[0].name;
    cardSingleType.value = clientComments.value[0].type;
    cardSingleComment.value = clientComments.value[0].comments;
}

function cardRight() {
    var elm = $('.current-card').attr('id');
    
    const clientFeedbackCardsWidth = $('#client-feedback-cards').width();
    const clientFeedbackCentreCardMarginVal = clientFeedbackCardsWidth * 0.25;
    const centerCardLeft = clientFeedbackCentreCardMarginVal;
    const centerCardRight = 0;
    const centerCardWidth = clientFeedbackCardsWidth - clientFeedbackCentreCardMarginVal - clientFeedbackCentreCardMarginVal;
    const rightCardLeft = clientFeedbackCardsWidth - 344;

    if(elm === 'client-feedback-card-one') {
        $('#client-feedback-card-one').removeClass('current-card');
        $('#client-feedback-card-three').addClass('current-card');   
        
        $('#client-feedback-card-two').animate({
            'z-index': '0',
            top:'65px',
            left:'0px',
            width:'344px',
            height:'264px',
            opacity: '0.85'
        },"slow");
        $('#client-feedback-card-one').animate({
            'z-index': '0',
            top: '65px',
            right: '0',
            left: rightCardLeft,
            width: '344px',
            height: '264px',
            opacity: '0.85'
        },"slow");
        $('#client-feedback-card-three').animate({
            'z-index': '10',
            top: '0',
            left: centerCardLeft,
            right: centerCardRight,
            height: '377px',
            width: centerCardWidth,
            opacity: '1'
        },"slow");

        var id = cardThreeId.value;
        var commentNumber = clientComments.value.length - 1;
        if(id === commentNumber) {
            id = 0;
        } else {
            id++;
        }   
        cardTwoName.value = clientComments.value[id].name;
        cardTwoType.value = clientComments.value[id].type;
        cardTwoComment.value = clientComments.value[id].comments;
        cardTwoId.value = id; 

        cardOneBlur.value = true;
        cardTwoBlur.value = true;
        cardThreeBlur.value = false;

    } else if(elm === 'client-feedback-card-two') {
        $('#client-feedback-card-two').removeClass('current-card');
        $('#client-feedback-card-one').addClass('current-card');
        $('#client-feedback-card-three').animate({
            'z-index': '0',
            top:'65px',
            left:'0px',
            width:'344px',
            height:'264px',
            opacity: '0.85'
        },"slow");
        $('#client-feedback-card-two').animate({
            'z-index': '0',
            top: '65px',
            right: '0',
            left: rightCardLeft,
            width: '344px',
            height: '264px',
            opacity: '0.85'
        },"slow");
        $('#client-feedback-card-one').animate({
            'z-index': '10',
            top: '0',
            left: centerCardLeft,
            right: centerCardRight,
            width: centerCardWidth,
            height: '377px',
            opacity: '1'
        },"slow");

        var id = cardOneId.value;
        var commentNumber = clientComments.value.length - 1;
        if(id === commentNumber) {
            id = 0;
        } else {
            id++;
        }
        cardThreeName.value = clientComments.value[id].name;
        cardThreeType.value = clientComments.value[id].type;
        cardThreeComment.value = clientComments.value[id].comments;
        cardThreeId.value = id; 

        cardOneBlur.value = false;
        cardTwoBlur.value = true;
        cardThreeBlur.value = true;

    } else if(elm === 'client-feedback-card-three') {
        $('#client-feedback-card-three').removeClass('current-card');
        $('#client-feedback-card-two').addClass('current-card');
        $('#client-feedback-card-one').animate({
            'z-index': '0',
            top:'65px',
            left:'0px',
            width:'344px',
            height:'264px',
            opacity: '0.85'
        },"slow");
        $('#client-feedback-card-three').animate({
            'z-index': '0',
            top: '65px',
            right: '0',
            left: rightCardLeft,
            width: '344px',
            height: '264px',
            opacity: '0.85'
        },"slow");
        $('#client-feedback-card-two').animate({
            'z-index': '10',
            top: '0',
            left: centerCardLeft,
            right: centerCardRight,
            width: centerCardWidth,
            height: '377px',
            opacity: '1'
        },"slow");

        var id = cardTwoId.value;
        var commentNumber = clientComments.value.length - 1;
        if(id === commentNumber) {
            id = 0;
        } else {
            id++;
        }

        cardOneName.value = clientComments.value[id].name;
        cardOneType.value = clientComments.value[id].type;
        cardOneComment.value = clientComments.value[id].comments;
        cardOneId.value = id; 

        cardOneBlur.value = true;
        cardTwoBlur.value = false;
        cardThreeBlur.value = true;

    } else {
        console.log('Error, we should not be here');
    }
}

function cardLeft() {
    var elm = $('.current-card').attr('id');
    
    const clientFeedbackCardsWidth = $('#client-feedback-cards').width();
    const clientFeedbackCentreCardMarginVal = clientFeedbackCardsWidth * 0.25;
    const centerCardLeft = clientFeedbackCentreCardMarginVal;
    const centerCardRight = 0;
    const centerCardWidth = clientFeedbackCardsWidth - clientFeedbackCentreCardMarginVal - clientFeedbackCentreCardMarginVal;
    const rightCardLeft = clientFeedbackCardsWidth - 344;
    
    if(elm === 'client-feedback-card-one') {
        $('#client-feedback-card-one').removeClass('current-card');
        $('#client-feedback-card-two').addClass('current-card');

        $('#client-feedback-card-one').animate({
            'z-index': '0',
            left:'0px',
            top:'65px',
            width:'344px',
            height:'264px',
            opacity: '0.85'
        },"slow");
        
        $('#client-feedback-card-three').animate({
            'z-index': '0',
            top: '65px',
            left: rightCardLeft,
            width: '344px',
            height: '264px',
            opacity: '0.85'
        },"slow");
        
        $('#client-feedback-card-two').animate({
            'z-index': '10',
            top: '0',
            left: centerCardLeft,
            right: centerCardRight,
            width: centerCardWidth,
            height: '377px',
            opacity: '1'
        },"slow");
       
        var id = cardTwoId.value;
        var commentNumber = clientComments.value.length - 1;
        if(id === commentNumber) {
            id = 0;
        } else {
            id++;
        }
        
        cardThreeName.value = clientComments.value[id].name;
        cardThreeType.value = clientComments.value[id].type;
        cardThreeComment.value = clientComments.value[id].comments;
        cardThreeId.value = id; 

        cardOneBlur.value = true;
        cardTwoBlur.value = false;
        cardThreeBlur.value = true; 

    } else if(elm === 'client-feedback-card-two') {
        $('#client-feedback-card-two').removeClass('current-card');
        $('#client-feedback-card-three').addClass('current-card');
        
        $('#client-feedback-card-two').animate({
            'z-index': '0',
            left:'0px',
            top:'65px',
            width:'344px',
            height:'264px',
            opacity: '0.85'
        },"slow");
        
        $('#client-feedback-card-one').animate({
            'z-index': '0',
            top: '65px',
            left: rightCardLeft,
            width: '344px',
            height: '264px',
            opacity: '0.85'
        },"slow");
        
        $('#client-feedback-card-three').animate({
            'z-index': '10',
            top: '0',
            left: centerCardLeft,
            right: centerCardRight,
            width: centerCardWidth,
            height: '377px',
            opacity: '1'
        },"slow");

        var id = cardThreeId.value;
        var commentNumber = clientComments.value.length - 1;
        if(id === commentNumber) {
            id = 0;
        } else {
            id++;
        }
        
        cardOneName.value = clientComments.value[id].name;
        cardOneType.value = clientComments.value[id].type;
        cardOneComment.value = clientComments.value[id].comments;
        cardOneId.value = id; 

        cardOneBlur.value = true;
        cardTwoBlur.value = true;
        cardThreeBlur.value = false;

    } else if(elm === 'client-feedback-card-three') {
        $('#client-feedback-card-three').removeClass('current-card');
        $('#client-feedback-card-one').addClass('current-card');

        $('#client-feedback-card-three').animate({
            'z-index': '0',
            left:'0px',
            top:'65px',
            width:'344px',
            height:'264px',
            opacity: '0.85'
        },"slow");
        
        $('#client-feedback-card-two').animate({
            'z-index': '0',
            top: '65px',
            left: rightCardLeft,
            width: '344px',
            height: '264px',
            opacity: '0.85'
        },"slow");
        
        $('#client-feedback-card-one').animate({
            'z-index': '10',
            top: '0',
            left: centerCardLeft,
            right: centerCardRight,
            width: centerCardWidth,
            height: '377px',
            opacity: '1'
        },"slow");

        var id = cardOneId.value;
        var commentNumber = clientComments.value.length - 1;
        if(id === commentNumber) {
            id = 0;
        } else {
            id++;
        }
        
        cardTwoName.value = clientComments.value[id].name;
        cardTwoType.value = clientComments.value[id].type;
        cardTwoComment.value = clientComments.value[id].comments;
        cardTwoId.value = id; 

        cardOneBlur.value = false;
        cardTwoBlur.value = true;
        cardThreeBlur.value = true;

    } else {
        console.log('Error, we should not be here');
    }
}

function cardLeftSingle() {
    var id = cardSingleId.value;
    var commentNumber = clientComments.value.length - 1;
    if(id === 0) {
        id = commentNumber;
    } else {
        id--;
    } 
    cardSingleName.value = clientComments.value[id].name;
    cardSingleType.value = clientComments.value[id].type;
    cardSingleComment.value = clientComments.value[id].comments;
    cardSingleId.value = id;
}

function cardRightSingle() {
    var id = cardSingleId.value;
    var commentNumber = clientComments.value.length - 1;
    if(id === commentNumber) {
        id = 0;
    } else {
        id++;
    } 
    cardSingleName.value = clientComments.value[id].name;
    cardSingleType.value = clientComments.value[id].type;
    cardSingleComment.value = clientComments.value[id].comments;
    cardSingleId.value = id;
}

function setBackground() {
    var setClass = 'client-feedback';
    if(backgroundColor.value === 'blue') {
        setClass = 'client-feedback-blue';
    } else {
        setClass = 'client-feedback';
    }
    return setClass;
}

function setHeaderColor() {
    var setClass = 'clarity-h3-blue';
    if(backgroundColor.value === 'blue') {
        setClass = 'clarity-h3-white';
    } else {
        setClass = 'clarity-h3-blue';
    }
    return setClass;
}

onMounted(() => {
    loadClientComments();

});

</script>

<template>
    <div :id="setBackground()">
        <div id="client-feedback-full">
            <div v-if="feedbackSourceType === 'all'">
                <h3 :class="setHeaderColor()" class="clarity-padding-top-2el clarity-padding-bottom-m text-center">WHAT OUR CLIENTS SAY</h3>
            </div>
            <div v-if="feedbackSourceType === 'pwc'">
                <h3 class="clarity-h3-blue clarity-padding-top-2el clarity-padding-bottom-m text-center">WHAT OTHER P<span class="lowercase">W</span>C CLIENTS SAY</h3>
            </div> 
            <div id="client-feedback-cards">
                <div id="client-feedback-card-one">
                    <img :class="{ 'client-feedback-card-img-blur': cardOneBlur }" class="client-feedback-img" :src="imgURL+'client-picture.png'" alt="Client Image">
                    <h4 :class="{ 'client-feedback-card-blur': cardOneBlur }" class="clarity-h4-blue text-center">{{ cardOneName }}</h4>
                    <p :class="{ 'client-feedback-card-blur': cardOneBlur }" class="clarity-small-grey-text mb-[15px]!">{{ cardOneType }}</p>
                    <ScrollPanel :class="{'client-feedback-card-scroll': !cardOneBlur}">
                        <p :class="{ 'client-feedback-card-blur': cardOneBlur }" class="clarity-body-text-grey">{{ cardOneComment }}</p>
                    </ScrollPanel>
                </div>
                <div @click="cardLeft" id="client-feedback-card-left"><span class="material-symbols-outlined">chevron_left</span></div>
                
                <div id="client-feedback-card-two" class="current-card">
                    <img :class="{ 'client-feedback-card-img-blur': cardTwoBlur }" class="client-feedback-img" :src="imgURL+'client-picture.png'" alt="Client Image">
                    <h4 :class="{ 'client-feedback-card-blur': cardTwoBlur }" class="clarity-h4-blue text-center">{{ cardTwoName }}</h4>
                    <p :class="{ 'client-feedback-card-blur': cardTwoBlur }" class="clarity-small-grey-text mb-[15px]!">{{ cardTwoType }}</p>
                    <ScrollPanel :class="{'client-feedback-card-scroll': !cardTwoBlur}">
                        <p :class="{ 'client-feedback-card-blur': cardTwoBlur }" class="clarity-body-text-grey">{{ cardTwoComment }}</p>
                    </ScrollPanel>
                </div>
                <div @click="cardRight" id="client-feedback-card-right"><span class="material-symbols-outlined">chevron_right</span></div>
                <div id="client-feedback-card-three" >
                    <img :class="{ 'client-feedback-card-img-blur': cardThreeBlur }" class="client-feedback-img" :src="imgURL+'client-picture.png'" alt="Client Image">
                    <h4 :class="{ 'client-feedback-card-blur': cardThreeBlur }" class="clarity-h4-blue text-center ">{{ cardThreeName }}</h4>
                    <p :class="{ 'client-feedback-card-blur': cardThreeBlur }" class="clarity-small-grey-text  mb-[15px]!">{{ cardThreeType }}</p>
                    <ScrollPanel :class="{'client-feedback-card-scroll': !cardThreeBlur}">
                        <p :class="{ 'client-feedback-card-blur': cardThreeBlur }" class="clarity-body-text-grey ">{{ cardThreeComment }}</p>
                    </ScrollPanel>
                </div>
            </div>
        </div>
        <div id="client-feedback-single">
            <div v-if="feedbackSourceType === 'all'">
                <h3 :class="setHeaderColor()" class="clarity-h3-blue clarity-padding-top-2el clarity-padding-bottom-m text-center">WHAT OUR CLIENTS SAY</h3>
            </div>
            <div v-if="feedbackSourceType === 'pwc'">
                <h3 class="clarity-h3-blue clarity-padding-top-2el clarity-padding-bottom-m text-center">WHAT OTHER P<span class="lowercase">W</span>C CLIENTS SAY</h3>
            </div> 

            <div @click="cardLeftSingle" id="client-feedback-card-left-single"><span class="material-symbols-outlined">chevron_left</span></div>
            
            <div id="client-feedback-card-single" class="current-card">
                <img class="client-feedback-img" :src="imgURL+'client-picture.png'" alt="Client Image">
                <h4 class="clarity-h4-blue text-center">{{ cardSingleName }}</h4>
                <p class="clarity-small-grey-text">{{ cardSingleType }}</p>
                <ScrollPanel class="client-feedback-card-scroll">
                    <p class="clarity-body-text-grey">{{ cardSingleComment }}</p>
                </ScrollPanel>
            </div>

            <div @click="cardRightSingle" id="client-feedback-card-right-single"><span class="material-symbols-outlined">chevron_right</span></div>

        </div>
    </div>
</template>

<style lang="css" scoped>
    #client-feedback-card-left {
        position: absolute;
        left: calc(23%);
        top: 180px;
        z-index: 11;
        cursor: pointer;
        width: 40px;
        height: 40px;
        background-color: var(--clarity-pure-white);
        border: 1px solid var(--clarity-grey);
        border-radius: 50px;
    }
    #client-feedback-card-left-single {
        position: absolute;
        left: calc(9%);
        margin-top: 168px;
        z-index: 11;
        cursor: pointer;
        width: 40px;
        height: 40px;
        background-color: var(--clarity-pure-white);
        border: 1px solid var(--clarity-grey);
        border-radius: 50px;
    }
    #client-feedback-card-left .material-symbols-outlined, #client-feedback-card-left-single .material-symbols-outlined  {
        padding-left: 5px;
        line-height: 40px;
    }
    #client-feedback-card-right {
        position: absolute;
        right: calc(23%);
        top: 180px;
        z-index: 11;
        width: 40px;
        height: 40px;
        background-color: var(--clarity-pure-white);
        border: 1px solid var(--clarity-grey);
        border-radius: 50px;
        cursor: pointer;
    }
    #client-feedback-card-right-single {
        position: absolute;
        right: calc(9%);
        margin-top: 168px;
        z-index: 11;
        width: 40px;
        height: 40px;
        background-color: var(--clarity-pure-white);
        border: 1px solid var(--clarity-grey);
        border-radius: 50px;
        cursor: pointer;
    }
    #client-feedback-card-right .material-symbols-outlined, #client-feedback-card-right-single .material-symbols-outlined {
        padding-left: 8px;
        line-height: 40px;
    }
    #client-feedback {
        max-width: 100%;
        height: 745px;
        background-image: v-bind(clientFeedbackBackground);
    }
    #client-feedback-blue {
        max-width: 100%;
        height: 745px;
        background-image: v-bind(clientFeedbackBlueBackground);
    }
    #client-feedback-single {
        display: none;
        margin: 0 auto;
    }
    .client-feedback-img {
        width: 90px;
        height: 90px;
        margin: 0px auto 20px auto;
    }
    #client-feedback-cards {
        position: relative;
        margin-left: calc(15%);
        margin-right: calc(15%);
    }
    #client-feedback-card-one {
        position: absolute;
        top: 65px;
        left: 0px;
        width: 344px;
        height: 264px;
        background-color: var(--clarity-pure-white);
        opacity: 0.40;
        box-shadow: 0px 0px 10px #0000001A;
        text-align: center;
        overflow: hidden;
        border-radius: 27px;
        padding: 30px;
    }
    #client-feedback-card-two {
        position: absolute;
        z-index: 10;
        left: calc(25%);
        right: calc(25%);
        height: 377px;
        background-color: var(--clarity-pure-white);
        box-shadow: 0px 0px 10px #0000001A;
        text-align: center;
        overflow: hidden;
        border-radius: 27px;
        padding: 30px;
    }
    #client-feedback-card-three {
        position: absolute;
        top: 65px;
        right: 0px;
        width: 344px;
        height: 264px;
        background-color: var(--clarity-pure-white);
        opacity: 0.40;
        box-shadow: 0px 0px 10px #0000001A;
        text-align: center;
        overflow: hidden;
        border-radius: 27px;
        padding: 30px;
    }
    #client-feedback-card-single {
        position: absolute;
        z-index: 10;
        left: calc(12%);
        right: calc(12%);
        height: 377px;
        background-color: var(--clarity-pure-white);
        box-shadow: 0px 0px 10px #0000001A;
        text-align: center;
        overflow: hidden;
        border-radius: 6px;
        padding: 30px;
    }
    .client-feedback-card-blur {
        color: transparent;
        text-shadow: 0 0 5px rgba(0,0,0,0.5);
    }
    .client-feedback-card-img-blur {
        filter: blur(4px);
    }
    .client-feedback-card-scroll {
        height: 150px;
        margin: 0px 20px 0px 20px;
    }
    .clarity-h4-blue {
        margin-bottom: 10px !important;
    }
    .lowercase {
        text-transform: lowercase !important;
    }
    /* Default Big Screen 1920px */
    /* Mid Screen */
    @media only screen and (max-width: 1366px) {}
    /* Small Screen */
    @media only screen and (max-width: 1024px) {}
    /* Tablet */
    @media only screen and (max-width: 767px) {
        #client-feedback-full {
            display: none;
        }
        #client-feedback-single {
            display: initial;
        }
    }
    /* Mobile */
    @media only screen and (max-width: 375px) {

    }
</style>